var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"t-table",class:[
    { 't-table--as-card': _vm.card } ]},[_c('thead',[_vm._t("head")],2),_vm._v(" "),_c('tbody',[_vm._t("default")],2),_vm._v(" "),_c('tfoot',[_vm._t("foot")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }